// extracted by mini-css-extract-plugin
export default {"search":"lR3l3o4xfs5sUQa2QB01","input":"_GwzK0NJmVyEXUp7ehXk"};